/**
 * Console brand vocabulary — the SINGLE source for the product/architecture
 * NAMES shown to developers. `UKS` and `TRAMA` are brand-facing (deliberately
 * NOT hidden): change a name here and every console surface follows.
 *
 * Exposed: the NAMES + the value they deliver. Kept opaque: the fusion
 * *mechanism* (how the UKS is built) — that stays out of the UI.
 */
export const UKS = "UKS";
export const UKS_FULL = "Unified Knowledge Schema";
export const TRAMA = "TRAMA";
